import React from "react";

const Kotlin_OOP = () => {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Kotlin OOP</h1>
      <p>Content for Kotlin OOP goes here.</p>
    </div>
  );
};

export default Kotlin_OOP;
